import { Col, Form, Input } from "antd";

const rules = {
  required: [{ required: true, message: "Campo obrigatório!" }],
};

const DescriptiveQuestion = ({ loading, obrigatorio, questao, id, defaultValue = "" }) => {
  return (
    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
      <Form.Item
        initialValue={defaultValue}
        name={["descriptive", `${id}`]}
        label={<strong>{questao}</strong>}
        rules={obrigatorio === 1 ? rules.required : null}>
        <Input.TextArea maxLength={2500} showCount size="large" disabled={loading} placeholder={questao} />
      </Form.Item>
    </Col>
  );
};

export { DescriptiveQuestion };
